"use strict";export var StorageType;(function(A){A[A.LOCAL_STORAGE=0]="LOCAL_STORAGE"})(StorageType||(StorageType={}));
